import apiSlice from "./apiSlice";
const safetyPackagesSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllSafety: builder.query({
      query: (req) => ({
        url: `safety`,
        params: req,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["AllSafety"],
    }),
    getSafetyPackages: builder.query({
      query: ({ projectId, type }) => {
        const params = new URLSearchParams();
        if (projectId) params.append("projectId", projectId);
        if (type) params.append("type", type);
        return `WBS?${params.toString()}`;
      },
    }),
  }),
});

export const {
  useGetSafetyPackagesQuery,
  useLazyGetSafetyPackagesQuery,
  useGetAllSafetyQuery,
} = safetyPackagesSlice;
